module.exports = __webpack_public_path__ + "img/pp-tablet.fc076142.webp";